import i18next from "../i18n";

export const experiences = {
  sectionTitle: i18next.t("experiences.sectionTitle"),
  icon: null,
  description: null,
  list: [
    {
      title: i18next.t("experiences.ciandt.title"),
      company: i18next.t("experiences.ciandt.company"),
      description: i18next.t("experiences.ciandt.description"),
      companyLink: i18next.t("experiences.ciandt.companyLink"),
      companyShortDetail: i18next.t("experiences.ciandt.companyShortDetail"),
      date: i18next.t("experiences.ciandt.date"),
    },
    {
      title: i18next.t("experiences.majime.title"),
      company: i18next.t("experiences.majime.company"),
      description: i18next.t("experiences.majime.description"),
      companyLink: i18next.t("experiences.majime.companyLink"),
      companyShortDetail: i18next.t("experiences.majime.companyShortDetail"),
      date: i18next.t("experiences.majime.date"),
    },
    {
      title: i18next.t("experiences.confidential.title"),
      company: i18next.t("experiences.confidential.company"),
      description: i18next.t("experiences.confidential.description"),
      companyLink: i18next.t("experiences.confidential.companyLink"),
      companyShortDetail: i18next.t(
        "experiences.confidential.companyShortDetail"
      ),
      date: i18next.t("experiences.confidential.date"),
    },
    {
      title: i18next.t("experiences.coorlab.title"),
      company: i18next.t("experiences.coorlab.company"),
      description: i18next.t("experiences.coorlab.description"),
      companyLink: i18next.t("experiences.coorlab.companyLink"),
      companyShortDetail: i18next.t("experiences.coorlab.companyShortDetail"),
      date: i18next.t("experiences.coorlab.date"),
    },
    {
      title: i18next.t("experiences.bxblue.title"),
      company: i18next.t("experiences.bxblue.company"),
      description: i18next.t("experiences.bxblue.description"),
      companyLink: i18next.t("experiences.bxblue.companyLink"),
      companyShortDetail: i18next.t("experiences.bxblue.companyShortDetail"),
      date: i18next.t("experiences.bxblue.date"),
    },
    {
      title: i18next.t("experiences.devops.title"),
      company: i18next.t("experiences.devops.company"),
      description: i18next.t("experiences.devops.description"),
      companyLink: i18next.t("experiences.devops.companyLink"),
      companyShortDetail: i18next.t("experiences.devops.companyShortDetail"),
      date: i18next.t("experiences.devops.date"),
    },
  ],
};

export default experiences;
